import PageContainer from '@/components/page-container'
import { transformToCreateUserDto } from '@/routes/admin/management/users/-components/user-dto'
import UserManagementForm from '@/routes/admin/management/users/-components/user-management-form'
import $api from '@/services/api'
import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'sonner'

export const Route = createFileRoute('/admin/management/users/create')({
  component: CreateUserManagement,
  staticData: {
    breadcrumb: 'Add New User',
  },
})

function CreateUserManagement() {
  const navigate = Route.useNavigate()
  const queryClient = useQueryClient()
  const mutation = $api.useMutation('post', '/users', {
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: $api.queryOptions('get', '/users').queryKey,
      })
      toast.success('User created successfully')
      navigate({ to: `..`, replace: true })
    },
    onError: (error) => {
      toast.error('Failed to create user', {
        description: (error as any)?.message || 'Something went wrong',
      })
    },
  })
  return (
    <PageContainer title="Add New User" backUrl="/admin/management/users">
      <UserManagementForm
        onSubmit={async (formValues) =>
          await mutation.mutateAsync({
            body: transformToCreateUserDto(formValues),
          })
        }
      />
    </PageContainer>
  )
}
